import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IAppConfig } from '../../common/model/app-config';
import { APPCONFIG } from '../../common/providers/config.provider';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AppSidenavMenuComponent } from '../../layout/sidenav/sidenav-menu/sidenav-menu.component';

@Component({
  selector: 'my-app-sidenav',
  styleUrls: ["./sidenav.component.scss"],
  templateUrl: './sidenav.component.html',
  standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		//TranslatePipe,
		AppSidenavMenuComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppSidenavComponent implements OnInit {
  AppConfig;
  swaggerURL;

  constructor(@Inject(APPCONFIG) public appConfig: IAppConfig) { }

  ngOnInit() {
    this.AppConfig = this.appConfig;
    this.swaggerURL = `${this.appConfig.serverUrl}/docs`;
  }

  toggleCollapsedNav() {
    this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
  }
}
